import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Select, MenuItem } from "@mui/material";
import axiosInstance from "../api/axiosInstance";

const REPORT_CATEGORIES = [
  "Spam",
  "Harassment",
  "Misinformation",
  "Hate Speech",
  "Violence",
  "Self-harm",
  "Scam/Fraud",
  "Illegal Content",
  "Sexually Explicit Content",
  "Other"
];

export default function ReportDialog({
  open,
  onClose,
  reportedEntityId,
  entityType,
}) {
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");

  const handleReport = async () => {
    if (!category || !description.trim()) {
      alert("Please select a category and provide details.");
      return;
    }

    try {
      await axiosInstance.post("/reports", {
        entity_id: reportedEntityId,
        entity_type: entityType,
        category,
        description,
      });
      alert("Your report has been submitted.");
      onClose();
      setCategory("");
      setDescription("");
    } catch (error) {
      console.error("Error reporting:", error);
      alert("Failed to submit report.");
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "12px", 
          padding: "15px",
          maxWidth: "450px",
          width: "90%",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontSize: "20px",
          fontWeight: "bold",
          textAlign: "center",
          color: "#333",
        }}
      >
        Report {entityType}
      </DialogTitle>
  
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          paddingBottom: "10px",
        }}
      >
        <Select
          fullWidth
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          displayEmpty
          variant="outlined"
          sx={{
            backgroundColor: "#f3f3f3",
            borderRadius: "8px",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#f3f3f3",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#f3f3f3",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#f3f3f3 !important",
            },
            "& .MuiSelect-icon": {
              color: "#2c3e50",
            },
          }}
        >
          <MenuItem value="" disabled>Select a category</MenuItem>
          {REPORT_CATEGORIES.map((cat) => (
            <MenuItem key={cat} value={cat}>{cat}</MenuItem>
          ))}
        </Select>
  
        <TextField
          label="Details"
          placeholder="Describe the issue..."
          multiline
          rows={4}
          fullWidth
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          margin="normal"
          variant="outlined"
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              backgroundColor: "#f3f3f3",
              "&.Mui-focused": {
                backgroundColor: "#f3f3f3",
              },
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#f3f3f3",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#f3f3f3",
            },
            "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#f3f3f3 !important",
            },
            "& .MuiInputLabel-root": {
              color: "#777",
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#999 !important",
            },
          }}
        />
      </DialogContent>
  
      <DialogActions
        sx={{
          justifyContent: "space-between",
          padding: "8px 24px",
        }}
      >
        <Button
          onClick={onClose}
          sx={{
            backgroundColor: "#f5f5f5",
            color: "#333",
            textTransform: "none",
            borderRadius: "8px",
            "&:hover": {
              backgroundColor: "#e0e0e0",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleReport}
          sx={{
            backgroundColor: "#d32f2f",
            color: "#fff",
            textTransform: "none",
            borderRadius: "8px",
            "&:hover": {
              backgroundColor: "#b71c1c",
            },
          }}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}